/* eslint-disable import/prefer-default-export */
import { fetch } from 'whatwg-fetch';
import { ajaxNew as ajax } from '../../../../scanline/utils/ajax';
import getAipUrls from '../../../../config/getAipUrls';

const CISV_FILE_UPLOAD_BUCKET = getAipUrls().cisvFileUploadBucket;

/** *********************************************
 * HELPERS
 */

const encodeData = data => {
  if (!data) {
    return data;
  }

	if (data instanceof Object || data instanceof Array) {
    return JSON.stringify(data);
  }

  return data;
};

const createPromiseRequest = ({
  url,
  data: paramData,
  method = 'GET',
  aip = 'platform',
  isAnonymous
}) => () => {
  const data = encodeData(paramData);	
  return new Promise((resolve, reject) => {
    ajax({
      url,
      data,
      method,
      callback: (err, res) => {
        if (err) {
          reject(err);
        } else {
          resolve(res);
        }
      },
      isAnonymous,
      aip
    });
  });
};

/** *********************************************
 * TEST STATIONS
 */

const createTestStationS3Params = ({ timeuuid } = {}) => {
	return {
		Bucket: CISV_FILE_UPLOAD_BUCKET,
		Key: `${timeuuid}/misc/testStations.json`,
		ContentType: 'application/json',
	}
}

/** *********************************************
 * SIGNED URLS
 */

const getSignedUrl = async ({ Bucket, Key, blnVersioned = false }) => {
  const post = createPromiseRequest({
    url: '/aegion-only-get-signed-url',
    data: { Bucket, Key, blnVersioned },
    method: 'POST',
    aip: 'platform',
  });

  return post().then(res => res?.url);
};


const getPutSignedUrl = async ({ Bucket, Key, ContentType = 'application/json' } = {}) => {
  const post = createPromiseRequest({
    url: '/aegion-only-get-signed-url',
    data: { Bucket, Key, blnWriteable: true, ContentType },
    method: 'POST',
    aip: 'platform',
  });

	return post().then(res => { 
		return res?.url;
	});
};



/** *********************************************
 * MAIN
 */

export const uploadTestStations = async (timeuuid, testStations) => {
	const { Bucket, Key, ContentType } = createTestStationS3Params({ timeuuid });
	const url = await getPutSignedUrl({ Bucket, Key, ContentType, blnWriteable: true });

	const response = await fetch(url, {
		method: 'PUT',
		headers: {
			'Content-Type': ContentType
		},
		body: encodeData(testStations)
	});

	if (!response.ok) {
		throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
	}

	return true;
}

export const downloadTestStations = async (timeuuid) => {
	let empty = false;
	let testStations = [];
	const { Bucket, Key, ContentType } = createTestStationS3Params({ timeuuid });
	const url = await getSignedUrl({ Bucket, Key, ContentType });

	const response = await fetch(url, {
    method: "GET"
  });

  if (!response.ok && response.status !== 404) {
    throw new Error(`Download failed: ${response.status} ${response.statusText}`);
	}
	
	if (response.status === 404) {
		empty = true;
	}

	if (response.ok) {
		const blob = await response.blob();
		const text = await blob.text();
		testStations = JSON.parse(text);
	}

	return { testStations, empty };
}
